import _mock from "../_mock";
import { randomInArray } from "../utils";

// ----------------------------------------------------------------------

export const _carouselsMembers = [...Array(6)].map((_, index) => ({
  id: _mock.id(index),
  name: _mock.name.fullName(index),
  role: _mock.role(index),
  avatar: `/assets/images/portraits/portrait_${index + 1}.jpg`,
}));

// ----------------------------------------------------------------------

export const _faqs = [...Array(8)].map((_, index) => ({
  id: _mock.id(index),
  value: `panel${index + 1}`,
  heading: `Questions ${index + 1}`,
  detail: _mock.text.description(index),
}));

// ----------------------------------------------------------------------

export const _addressBooks = [...Array(5)].map((_, index) => ({
  id: _mock.id(index),
  receiver: _mock.name.fullName(index),
  fullAddress: _mock.address.fullAddress(index),
  phone: _mock.phoneNumber(index),
  addressType: index === 0 ? "Home" : "Office",
  isDefault: index === 0,
}));

// ----------------------------------------------------------------------

export const _skills = [...Array(3)].map((_, index) => ({
  label: ["Development", "Design", "Marketing"][index],
  value: _mock.number.percent(index),
}));

// ----------------------------------------------------------------------

export const _contacts = [...Array(20)].map((_, index) => ({
  id: _mock.id(index),
  name: _mock.name.fullName(index),
  username: _mock.name.fullName(index),
  avatar: _mock.image.avatar(index),
  address: _mock.address.fullAddress(index),
  phone: _mock.phoneNumber(index),
  email: _mock.email(index),
  lastActivity: _mock.time(index),
  status: randomInArray(["online", "offline", "away", "busy"]),
  role: _mock.role(index),
}));

// ----------------------------------------------------------------------

export const _notifications = [...Array(5)].map((_, index) => ({
  id: _mock.id(index),
  title: [
    "Your order is placed",
    "Sylvan King",
    "You have new message",
    "You have new mail",
    "Delivery processing",
  ][index],
  description: [
    "waiting for shipping",
    "answered to your comment on the Minimal",
    "5 unread messages",
    "sent from Guido Padberg",
    "Your order is being shipped",
  ][index],
  avatar: [null, _mock.image.avatar(2), null, null, null][index],
  type: [
    "order_placed",
    "friend_interactive",
    "chat_message",
    "mail",
    "order_shipped",
  ][index],
  createdAt: _mock.time(index),
  isUnRead: [true, true, false, false, false][index],
}));

// ----------------------------------------------------------------------

export const _mapContact = [
  {
    latlng: [33, 65],
    address: _mock.address.fullAddress(1),
    phoneNumber: _mock.phoneNumber(1),
  },
  {
    latlng: [-12.5, 18.5],
    address: _mock.address.fullAddress(2),
    phoneNumber: _mock.phoneNumber(2),
  },
];

// ----------------------------------------------------------------------

export const _rankList = [...Array(24)].map((_, index) => ({
  id: _mock.id(index),
  name: _mock.name.fullName(index),
  company: _mock.company(index),
  rank: _mock.number.rating(index),
}));

// ----------------------------------------------------------------------

const status = ["available", "busy"];
// branch dummy data
export const _branchesList = [...Array(25)].map((_, index) => ({
  id: _mock.id(index),
  name: "Branch",
  status: status[Math.trunc(Math.random() * status.length)],
  location: "St Georgica Terrace, Perth",
  total_order: _mock.number.age(index),
  completed_order: _mock.number.age(index),
  reviews: _mock.number.age(index),
}));
//________________________________________________________________
// newBranches dummy data
const newBranchesStatus = ["pending", "rejected"];
export const _newBranchesList = [...Array(25)].map((_, index) => ({
  name: 'Branch',
  status: status[Math.trunc(Math.random() * status.length)],
  location: 'St Georgica Terrace, Perth',
  total_orders: _mock.number.age(index),
  completed_orders: _mock.number.age(index),
  reviews: _mock.number.age(index),
}));
//_______________________________________________________________________
// users dummy data
export const _usersList = [...Array(25)].map((_, index) => ({
  id: _mock.id(index),
  user_name: 'Ahmed sayed',
  branche_name: 'KFC 1',
  position: 'Manager',
  email: _mock.email(index),
  phone_number: _mock.phoneNumber(2),

}));
//____________________________________________________________________
const menuStatus = [1, 0];
export const _MenuList = [...Array(25)].map((_, index) => ({
  category_name: 'Fried chickens',
  number_of_items: '220',
  number_of_orders: '220',
  category_status: menuStatus[Math.trunc(Math.random() * menuStatus.length)],
}));
//_____________________________________________________________________
const MenuList2 = ['Available', 'Not available']
export const _MenuList2 = [...Array(25)].map((_, index) => ({
  name: 'Mighty Zinger',
  category: 'Fried Chicken',
  price: 'AED 55,00',
  no_of_orders: '200',
  preparation_time: '20 min',
  item_status: MenuList2[Math.trunc(Math.random() * MenuList2.length)],
}));
//_________________________________________________________________________
export const _MenuList3 = [...Array(25)].map((_, index) => ({
  name: 'Mighty Zinger',
  offer_type: 'Combo',
  price: 'AED 55,00',
  no_of_orders: '200',
  start_date: '10/11/2020',
  end_date: '10/11/2020',
}));

export const _Products = [...Array(25)].map((_, index) => ({
  name: 'Mighty Zinger',
  category: 'greens',
  price: 'AED 55,00',
  no_of_orders: '200',
  preperation_time: '20',
  status: menuStatus[Math.trunc(Math.random() * menuStatus.length)],

}));

const status2 = ['Pending', 'Rejected']
// branch dummy data
export const _mybranchesList2 = [...Array(25)].map((_, index) => ({
  id: _mock.id(index),
  name: 'Branch',
  status: status2[Math.trunc(Math.random() * status2.length)],
  location: 'St Georgica Terrace, Perth',
  total_order: _mock.number.age(index),
  completed_order: _mock.number.age(index),
  reviews: _mock.number.age(index),
}));

// newBranches dummy data
const newBranchesStatus2 = ['pending', 'rejected']
export const _newBranchesList2 = [...Array(25)].map((_, index) => ({
  id: _mock.id(index),
  name: 'Branch',
  status: newBranchesStatus2[Math.trunc(Math.random() * status2.length)],
  location: 'St Georgica Terrace, Perth',
  data_completeness: _mock.number.age(index),

}));
export const _branchList = [...Array(25)].map((_, index) => ({
  id: _mock.id(index),
  name: "Branch",
  status: newBranchesStatus[Math.trunc(Math.random() * status.length)],
  location: "St Georgica Terrace, Perth",
  dateCompleted: _mock.number.percent(index),
}));



//  Invoices
const invoiceStatus = ['succeed', 'failed']
export const _invoicesList = [...Array(25)].map((_, index) => ({
  id: _mock.id(index),
  userName: 'Mahmoud Sabri',
  branchName: 'KFC1',
  requestDate: '20-2-2023',
  withdrawDate: '20-2-2023',
  invoiceValue: '30,200',
  invoiceStatus: invoiceStatus[Math.trunc(Math.random() * status2.length)],
}))

//  ranking

export const _rankingList = [...Array(25)].map((_, index) => ({
  id: _mock.id(index),
  branchManager: 'Mahmoud Sabri',
  branchName: 'KFC1',
  rate: 4.9,
  totalReviews: 100,
  goodReviews: 20,
  badReviews: 20,
}))

//finance
const financeStatus = ['succeed', 'failed']
export const _financeTable = [...Array(25)].map((_, index) => ({
  invoice_id: _mock.id(index),
  user_name: 'Ahmed sayed',
  request_date: '20/2/2021',
  withdraw_date: '20/2/2021',
  invoice_value: 'AED 30,200',
  invoice_statue: financeStatus[Math.trunc(Math.random() * financeStatus.length)],

}))
// pending Oreders
export const _PendingOrders = [...Array(25)].map((_, index) => ({
  id: _mock.id(index),
  orderTime: '10 : 20',
  orderLocation: 'St Georgica Terrace, Perth',
  meals: 3,
  price: '55,00',
  deliveryName: 'Ahmed gamal',
  orderStatus: 'pending',
}))

// All Oreders
const orderStatus = ['pending', 'delivered', 'canceled'];
export const _AllOrders = [...Array(25)].map((_, index) => ({
  id: _mock.id(index),
  orderTime: '10 : 20',
  preparationTime: '20',
  orderLocation: 'St Georgica Terrace, Perth',
  meals: 3,
  price: '55,00',
  deliveryName: 'Ahmed gamal',
  orderStatus: orderStatus[Math.trunc(Math.random() * orderStatus.length)],
}))
